import {DISPLAY_ERROR__ACTIONTYPE, DISMISS_ERROR__ACTIONTYPE} from '../../constants/global';

const ERROR_TIMEOUT_MS: number = 3000;

export function flashError(error: Error): ThunkAction<void> {
	return dispatch => {
		dispatch(displayError(error));
		setTimeout(() => {
			dispatch(dismissError(error));
		}, ERROR_TIMEOUT_MS);
	};
}

function displayError(error: any): DisplayErrorAction {
	return {
		type: DISPLAY_ERROR__ACTIONTYPE,
		displayErrorData: {error},
		scope: 'GLOBAL_ACTION_SCOPE',
	};
}

export function dismissError(error: any): DismissErrorAction {
	return {
		type: DISMISS_ERROR__ACTIONTYPE,
		dismissErrorData: {error},
		scope: 'GLOBAL_ACTION_SCOPE',
	};
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/actions/util/errors.ts